import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LeadIdType, ILeadShortInfoState, ILeadMappedModel } from './types';

export const STORE_NAME = 'leadShortInfo';

const INIT_LEAD_INFO: ILeadShortInfoState['leadInfo'] = {
  leadData: null,
  isLoading: true,
  isPermissionError: false,
};

const INIT_STATE: ILeadShortInfoState = {
  leadInfo: INIT_LEAD_INFO,
  hasRightForWatchInfo: false,
};

const leadShortInfoStore = createSlice({
  name: STORE_NAME,
  initialState: INIT_STATE,
  reducers: {
    setHasRightFortWatchInfo: (
      state,
      { payload: canWatchLeadInfo }: PayloadAction<boolean>
    ) => {
      state.hasRightForWatchInfo = canWatchLeadInfo;
    },
    setInitLeadState: (state) => {
      state.leadInfo = INIT_LEAD_INFO;
    },
    setLeadData: (
      state,
      { payload: leadData }: PayloadAction<ILeadMappedModel>
    ) => {
      state.leadInfo.leadData = leadData;
    },
    setIsLoading: (state, { payload: isLoading }: PayloadAction<boolean>) => {
      state.leadInfo.isLoading = isLoading;
    },
    setIsPermissionError: (
      state,
      { payload: isPermissionError }: PayloadAction<boolean>
    ) => {
      state.leadInfo.isPermissionError = isPermissionError;
    },
    removeLead: (state, { payload: leadId }: PayloadAction<LeadIdType>) => {
      delete state[leadId];
    },
  },
});

const LOAD_LEAD = `${STORE_NAME}/leadLoad`;

export const leadShortInfoActions = {
  leadLoad: createAction<number>(LOAD_LEAD),
  setLeadData: leadShortInfoStore.actions.setLeadData,
  setIsPermissionError: leadShortInfoStore.actions.setIsPermissionError,
  removeInfo: leadShortInfoStore.actions.removeLead,
  setIsLoading: leadShortInfoStore.actions.setIsLoading,
  setInitLeadState: leadShortInfoStore.actions.setInitLeadState,
  setHasRightFortWatchInfo: leadShortInfoStore.actions.setHasRightFortWatchInfo,
};

export const leadShortInfoReducer = leadShortInfoStore.reducer;
